import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { IoCheckmarkCircle } from "react-icons/io5";
import { resetWpsState, resetWpsPage } from "../../../store";

const Confirmation = ({ progress }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const handleGoBackHome = () => {
    dispatch(resetWpsState());
    dispatch(resetWpsPage(0));
    navigate("/dashboard");
	};

	const handleSurveyNavigation = () => {
		dispatch(resetWpsState());
		dispatch(resetWpsPage(0));
		navigate("/surveywps");
	};

	useEffect(() => {
		window.scrollTo(0,280)
	}, [])

  let orderNumber = useSelector(state => state.wpsForm.data.orderNumber)
  let billingType = useSelector(state => state.wpsForm.billingInformation.billingMethod)


  return (
    <div className="px-8 xl:px-16">
		<h1 className='text-3xl xl:text-4xl text-[var(--color-primary-purple)] font-black my-[40px]'>
			Whole Plasmid Sequencing
        </h1>
      <div className='flex flex-col justify-center items-center'>
      <div className="w-full overflow-hidden">
          {progress}
          </div>
        <IoCheckmarkCircle className='h-[124px] w-[124px] text-[#60C5C5] mt-14 mb-10' />
        <p className='text-[var(--color-primary-purple)] font-bold text-3xl'>
        <b>Order Confirmed!</b>
        </p>
        <div className='flex flex-col justify-center items-center mt-8 mb-12 w-[60%] text-center'>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg'>
            Thank you for placing an order with us.
          </p>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg'>
            Your order number is <b>{orderNumber}</b>. 
          </p>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg'>
            Please make sure this number is clearly visible on the package containing your samples, either written on the outside of the package in permanent marker or on a small piece of paper sealed within the bag.
          </p>
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg mt-3'>
          You can track the status of your order at any time by going to My Orders on your account dashboard.
          </p>
          {/* <p className="text-blue-700">Link to shipping instructions</p> */}
          {billingType.includes("Purchasing") && 
          <p className='text-[var(--color-primary-purple)] font-semibold text-lg mt-6'>
            You will receive an email shortly with the link and code which is to be forwarded to PA.
          </p>
          }
        </div>

		<button
			className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[289px] h-[43px] mb-16'
			onClick={() => handleGoBackHome()}
		>
			go back to account home
		</button>
	
      </div>
    </div>
  );
};

export default Confirmation;
